import {AuthHeader} from "../configs/auth.token";

export const AxiosConfig = (no_cache=false) => {
	if (no_cache) {
		return {
			headers: {
				Authorization : AuthHeader(),
				'Cache-Control': 'no-cache',
			}
		}
	} else {
		return {
			headers: {
				Authorization : AuthHeader(),
			}
		}
	}
};
